import React, { useRef, useState, useEffect } from 'react';
import '../styles/Ensemble.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReservationService from '../services/reservationSalleService';
import VehiculeMissionService from '../services/vehiculeMissionService';
import AbsencePersonnelService from '../services/absencePersonnelService'
import PersonnelList from '../components/PersonnelList';
import PersonIcon from '@mui/icons-material/Person';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import GroupsIcon from '@mui/icons-material/Groups';
import { useNavigate, Link } from 'react-router-dom';
import AuthService from '../services/authService';


function Ensemble() {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [vehicules, setVehicules] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [personnels, setPersonnels] = useState([]);
  const navigate = useNavigate();
  const [conge, setConge] = useState([]);
  const [mission, setMission] = useState([]);
  const [reposMaladie, setReposMaladie] = useState([]);

  const vehiculeRef = useRef(null);
  const reservationRef = useRef(null);
  const missionRef = useRef(null)
  const congeRef = useRef(null);
  const reposRef = useRef(null);

    // Function to handle logout
    const handleLogout = () => {
      AuthService.deconnection(); 
      navigate('/login');
    };

  // RECUPERE LES DONNEES DE LA BASE DE DONNEES
  const fetchData = () => {
    ReservationService.all()
      .then(result => {
        if (result.success) {
          setReservations(result.data['data']);
        }
      }).catch(error => alert(error.error));

    VehiculeMissionService.all()
      .then(result => {
          setVehicules(result.data);
      }).catch(error => alert(error.error));

    AbsencePersonnelService.all()
      .then(result => {
        if (result.success) {
          setPersonnels(result.data['data']);
        }
      }).catch(error => alert(error.error));
  }

  // VERIFIE CHAQUE 10 SECONDES SI UNE SALLE EST OCCUPEE
  useEffect(() => {
    const timer = setInterval(() => {
      ReservationService.dateHeure()
        .then(result => {
          if (result.success) {
            setCurrentDateTime(new Date(result.data));
            reservations.map((item, index) => {
              const debut = new Date(formatDate(item.debut));
              const fin = new Date(formatDate(item.fin));
              if (currentDateTime >= fin) {
                ReservationService.date_expire(item.id_reservation)
              }
            });

          }
        })
        .catch(error => alert(error.error));
    }, 10000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    fetchData();
  }, [currentDateTime]);

  // FORMAT DATE
  const formatDate = (dateString) => {
    return dateString.replace('Z', '');
  }

  const formatDateVue = (dateString) => {
    const months = ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];
    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes] = timePart.split(':');
    const formattedMonth = months[parseInt(month) - 1]; // Convertir mois en format lisible
    return `${parseInt(day)} ${formattedMonth} à ${hours}h${minutes}`;
  };

  const formatDateVue2 = (dateString) => {
    const months = ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];
    const [datePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    const formattedMonth = months[parseInt(month) - 1];
    return `${parseInt(day)} ${formattedMonth}`;
  };


  // ANIMATION DES ELEMENTS
  useEffect(() => {
    const scrollContainer = (ref, condition) => {
      const container = ref.current;
      if (condition) {
        const childHeight = container.children[0].offsetHeight;
        container.style.transition = 'transform 3s linear';
        container.style.transform = `translateY(-${childHeight+10}px)`;

        setTimeout(() => {
          container.style.transition = 'none';
          container.style.transform = 'translateY(0)';
          container.appendChild(container.children[0]);
        }, 3000);
      }
    };

    const vehiculeCondition = vehicules.length >= 4;
    const reservationCondition = reservations.length >= 4;
    const missionCondition = mission.length >= 5;
    const congeCondition = conge.length >= 5;
    const reposCondition = reposMaladie.length >= 5;

    const vehiculeInterval = vehiculeCondition ? setInterval(() => scrollContainer(vehiculeRef, vehiculeCondition), 8000) : null;
    const reservationInterval = reservationCondition ? setInterval(() => scrollContainer(reservationRef, reservationCondition), 8000) : null;
    const missionInterval = missionCondition ? setInterval(() => scrollContainer(missionRef, missionCondition), 8000) : null;
    const congeInterval = congeCondition ? setInterval(() => scrollContainer(congeRef, congeCondition), 1000) : null;
    const reposInterval = reposCondition ? setInterval(() => scrollContainer(reposRef, reposCondition), 1000) : null;

    return () => {
      if (vehiculeInterval) clearInterval(vehiculeInterval);
      if (reservationInterval) clearInterval(reservationInterval);
      if (missionInterval) clearInterval(missionInterval);
      if (congeInterval) clearInterval(congeInterval);
      if (reposInterval) clearInterval(reposInterval);
    };
  }, [vehicules, reservations, mission, conge, reposMaladie]);


  useEffect(() => {
    setMission(personnels.filter(person => person.id_statut_absence === 3));
    setConge(personnels.filter(person => person.id_statut_absence === 1));
    setReposMaladie(personnels.filter(person => person.id_statut_absence === 2));
  }, [personnels]);

  
  function PartieRH(code) {
    const codesAutorises = ['RA', 'ARH','RSI','RBD','CEO','SBD'];
    const estAutorise = codesAutorises.includes(code.toUpperCase());
    if (estAutorise) {
      return <Link className='btn-reserver' to={"/absence"}>RH</Link>;
    }
  }

  function PartieLogistique(code) {
    const codesAutorises = ['RLS','ARLC','AALPPSB','AALVACCIN','RSI','RBD','CEO','SBD'];
    const estAutorise = codesAutorises.includes(code.toUpperCase());
    if (estAutorise) {
      return <Link className='btn-reserver' to={"/vehicule"}>Logistique</Link>;
    }
  }

  return (
    <div className="all">
      <div className="container-fluid" >
        <button style={{background:'transparent',border:'1px solid'}} onClick={handleLogout}>deconnection</button>
        <div className="row">
          <div className="entite col-sm-12 col-lg-4 col-md-6">
            <div className="entite-nom">
              <GroupsIcon className='entite-icon' /> RESERVATION SALLE
            </div>
            <div className="list-salle">
              <div className="scroll-container" ref={reservationRef}>
                {reservations.map((item, index) => {
                  const debut = new Date(formatDate(item.debut));
                  const fin = new Date(formatDate(item.fin));
                  const isCurrentReunion = currentDateTime >= debut && currentDateTime <= fin;
                  return (
                    <div className="salle" key={index}>
                      <div className='nom-salle' style={{ backgroundColor: isCurrentReunion ? '#DD1921' : '', color: isCurrentReunion ? 'white' : '' }}>
                        <span>{item.salle}</span>
                      </div>
                      <div className="salle-details">
                        <div className="d-flex flex-wrap">
                          <div className="col-12">
                            {formatDateVue(item.debut)} <span style={{ padding: '0px 10px' }}>-</span> {formatDateVue(item.fin)}
                          </div>
                          <div className="col-12"><span>Participant:</span> {item.participant}</div>
                          <div className="col-12"><span>Financement:</span> {item.financement}</div>
                          <div className="col-12"><span>Demandeur:</span> {item.demandeur}</div>
                          <div className="col-12"><span>Objet:</span> {item.objet}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div>
              <Link className='btn-reserver' to={"/reunion"}>Reserver</Link>
            </div>
          </div>

          <div className="entite col-sm-12 col-lg-4 col-md-6">
            <div className="entite-nom">
              <DriveEtaIcon className='entite-icon' /> VEHICULE
            </div>
            <div className="list-salle">
              <div className="scroll-container" ref={vehiculeRef}>
                {
                  vehicules.map((item, index) => (
                    <div className="salle" key={index}>
                      <div className="nom-salle"><span>{item.nom_marque} - {item.nom_bailleur}</span></div>
                      <div className="salle-details">
                        <div className="d-flex flex-wrap">
                          <div className="col-12">
                            {formatDateVue2(item.date_debut)} <span>-</span> {formatDateVue2(item.date_fin)}
                          </div>
                          <div className="col-12"><span>Chauffeur:</span> {item.code_chauffeur} : {item.prenom_chauffeur}</div>
                          <div className="col-12"><span>Missionaires: </span> {item.missionnaires}</div>
                          <div className="col-12"><span>Lieu:</span> {item.lieu}</div>
                          <div className="col-12"><span>Marque/Modèle/num:</span> {item.nom_marque}/{item.nom_modele}/{item.num_vehicule}</div>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
            <div>
              {PartieLogistique(AuthService.getCode())}
            </div>
          </div>

          <div className="entite col-sm-12 col-lg-4 col-md-6">
            <div className="entite-nom">
              <PersonIcon className='entite-icon' /> PERSONNEL
            </div>
            <PersonnelList title="MISSION" items={mission} refProp={missionRef} />
            <PersonnelList title="CONGE" items={conge} refProp={congeRef} />
            <PersonnelList title="REPOS MALADIE" items={reposMaladie} refProp={reposRef} />
            <div>
              {PartieRH(AuthService.getCode())}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ensemble;
